import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../../components/common/Spinner/Spinner';
import styles from './LandingPage.module.css';
import { useAuth } from '../../app/auth/AuthContext';

const LandingPage: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate('/opdrachten');
      return;
    }

    switch (user?.role) {
      case 'STUDENT':
        navigate('/student/overzicht');
        break;
      case 'TEACHER':
        navigate('/docent/klassen');
        break;
      case 'ADMIN':
        navigate('/evenementen');
        break;
      default:
        navigate('/login');
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
};

export default LandingPage;
